const getRateLimitMessage = error => {
  if (!error || typeof error !== 'object') return null
  if (Number(error.status_code ?? error.statusCode ?? error.status) !== 429) return null

  const retryAfterSeconds = Number(error.retry_after_seconds)
  if (!Number.isFinite(retryAfterSeconds) || retryAfterSeconds < 0) {
    return 'Too many requests. Please try again later.'
  }

  if (retryAfterSeconds < 60) {
    return `Too many requests. Please try again in ${Math.ceil(retryAfterSeconds)} seconds.`
  }

  const minutes = Math.ceil(retryAfterSeconds / 60)
  return `Too many requests. Please try again in ${minutes} minute${minutes === 1 ? '' : 's'}.`
}

export { getRateLimitMessage }
